import React, { Component } from 'react';
import { get, find } from 'lodash';
import { connect } from 'react-redux';

import GroupCard from '../../components/my-groups/group-card';
import { extractImage, LARGE_FOUR_THIRD } from '../../lib/image-versions';
import { getCurrentUserPurchases } from '../../selectors/user-selector';
import Purchase from '../../lib/purchase';

class GroupsContainer extends Component {
  renderPurchases() {
    const { purchases } = this.props;
    return purchases.map(purchase => this.renderPurchase(purchase));
  }

  renderPurchase(purchase) {
    const image = extractImage(
      purchase.product.images,
      LARGE_FOUR_THIRD,
      purchase.product.defaultImageUrl
    );

    return (
      <GroupCard
        imageUrl={image.url}
        createdAt={purchase.createdAt}
        status={purchase.status}
        isCompleted={Purchase.isCompleted(purchase)}
        name={purchase.product.name}
        deadline={purchase.group.commitDeadline}
        url={`/purchases/${purchase.slug}`}
        committedMembers={purchase.committedMembers}
        invitedMembers={purchase.invitedMembers}
        organizerName={purchase.organizerUser.fullName}
        expired={Purchase.isDateExpired(purchase.group.commitDeadline)}
        key={purchase.id}
        purchase={purchase}
      />
    );
  }

  render() {
    return (
      <div className="row">
        {this.renderPurchases()}
      </div>
    );
  }
}

const getMemberships = (purchase, memberships) => {
  const purchaseMembers = get(purchase, 'memberships', []);
  return purchaseMembers.map(id => memberships.byId[id]);
};

const getCommittedMemberships = (purchase, memberships) => {
  const purchaseMembers = getMemberships(purchase, memberships);
  return purchaseMembers.filter(m => m.status === 'committed');
};

const getHoldoutMembers = (purchase, memberships) => {
  const purchaseMembers = getMemberships(purchase, memberships);
  return purchaseMembers.filter(m => m.status === 'holdout');
};

const getOrganizerMembership = (purchase, memberships) => {
  const purchaseMembers = getMemberships(purchase, memberships);
  return find(purchaseMembers, m => m.role === 'organizer');
};

const mapStateToProps = (state) => {
  const { memberships } = state;
  const compilePurchase = (purchase) => {
    return {
      committedMembers: getCommittedMemberships(purchase, memberships).length,
      invitedMembers: getHoldoutMembers(purchase, memberships).length,
      organizerUser: getOrganizerMembership(purchase, memberships).user,
      ...purchase,
    };
  };

  return {
    purchases: getCurrentUserPurchases(state).map(compilePurchase),
  };
};

export default connect(mapStateToProps)(GroupsContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/my-groups/groups.container.js